import { render, staticRenderFns } from "./NumberOfPeopleInsideLineChart.vue?vue&type=template&id=634a3d53&"
import script from "./NumberOfPeopleInsideLineChart.vue?vue&type=script&lang=js&"
export * from "./NumberOfPeopleInsideLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports